import {Component, HostBinding} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';

@Component({
    selector: 'app-label',
    template: `
            <div class="ion-margin-horizontal ion-padding-horizontal d-block">
                <ng-content></ng-content>
            </div>
    `,
    imports: [CommonModule, IonicModule]
})
export class AppLabelComponent {
    @HostBinding('class') classes = 'd-block ion-margin-horizontal ion-padding-horizontal';
}
